export const ERROR_MSGS = {
  REFUNDED: 'Envelope has been refunded',
  ALREADY_REDEEMED: 'Envelope was already redeemed.',
};
export const VOIDED_BG_COLOR_HEX = '#646464';
export const BARCODE_BG_COLOR_HEX = '#F6F6F6FF';
export const TICKET_BG_COLOR_HEX = '#ffffff';
export const BARCODE_BORDER_COLOR_HEX = '#EBEBEBFF';
export const VOIDED_TEXT_COLOR_HEX = '#ffffff';
